export { ZebraPrintModule } from './src/app/zebra-print.module';
export { ZebraTemplateService } from './src/app/services/zebra-template.service';
export { ZebraBrowserPrint } from './src/app/classes/zebra-browser-print';



// WEBPACK FOOTER //
// ./libs/zebra-print/index.ts